<template>
  <b-row class="pt-3 pb-5">
    <b-col>
      <!-- <AddButton btnname="+ Add all items to the request" class="btn-class-name" @click="$.emit('SelectAll')"></AddButton> -->

      <AddButton btnname="+ Add Selected items to the request" class="btn-class-name" @click="$.emit('AddSingleClick')">
      </AddButton>
    </b-col>
  </b-row>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import Dropdown from "../../../../components/FormComponents/Dropdown.vue";
import TextInput from "../../../../components/FormComponents/TextInput.vue";
import AddButton from "../../../../components/GeneralButtons/AddButton.vue";

export default defineComponent({
  components: {
    Dropdown,
    Headerlayout,
    TextInput,
  },
  setup() {
    return {};
  },
});
</script>
<style lang="scss">
.btn-class-name {
  padding: 0.5rem 0.75rem !important;
  font-size: 14px !important;
}
</style>
